/* Logo IA Orbit — remplace l'icône IA par défaut partout dans l'application */
export const OrbitAI = ({ className = "w-4 h-4", ...rest }) => <img src="/orbit-ai.png" alt="IA Orbit" draggable={false} className={`object-contain select-none ${className}`} {...rest} />;
export default OrbitAI;
